export default function resizeExpandCanvas(canvas, width, height) {
  if (!canvas) {
    return;
  }

  canvas.setDimensions({
    width,
    height,
  });
  canvas.calcOffset();
}
